export type EntityType = "facebook" | "instagram" | "whatsapp" | "widget";

export interface ChatbotConfig {
  id: string;
  entityId: string;
  entityType: EntityType;
  enabled: boolean;
  name?: string;
  description?: string;

  appearance: {
    primaryColor: string;
    secondaryColor: string;
    textColor: string;
    backgroundColor: string;
    borderRadius: number;
    position: "bottom-right" | "bottom-left";
    logoUrl?: string;
    avatarUrl?: string;
    avatarFile?: File;
    launcherImageUrl?: string;
    launcherFile?: File;
    darkMode?: boolean;
  };

  behavior: {
    welcomeMessage: string;
    placeholderText: string;
    autoOpen: boolean;
    autoOpenDelay: number;
    typingAnimation: boolean;
    soundEnabled: boolean;
    handoffEnabled: boolean;
    botTakeoverName: string;
    agentTakeoverName: string;
  };

  ai: {
    systemPrompt: string;
    language: string;
    fallbackMessage: string;
  };

  escalation: {
    enabled: boolean;
    handoffAfterMessages: number;
    handoffConfidenceThreshold: number;
  };

  dataSources: {
    pdfs: string[];
    urls: string[];
    faqs: Array<{
      question: string;
      answer: string;
    }>;
    customText: string;
  };

  vectorNamespace: string;
  links?: Array<{
    text: string;
    url: string;
    iconUrl?: string;
  }>;
  createdAt?: string;
  updatedAt?: string;
}

export const defaultChatbotConfig: Omit<
  ChatbotConfig,
  "id" | "entityId" | "entityType" | "vectorNamespace"
> = {
  enabled: true,

  appearance: {
    primaryColor: "#4D1277",
    secondaryColor: "#6BE900",
    textColor: "#2d3748",
    backgroundColor: "#ffffff",
    borderRadius: 12,
    position: "bottom-right",
    launcherImageUrl: "",
    avatarUrl: "",
  },

  behavior: {
    welcomeMessage: "Hi! How can I help you today?",
    placeholderText: "Type your message...",
    autoOpen: false,
    autoOpenDelay: 3000,
    typingAnimation: true,
    soundEnabled: false,
    handoffEnabled: true,
    botTakeoverName: "Chat Support",
    agentTakeoverName: "Live Support",
  },

  ai: {
    systemPrompt: "You are a helpful customer support assistant.",
    language: "en",
    fallbackMessage:
      "I'm not sure about that. Let me connect you with a team member.",
  },

  escalation: {
    enabled: true,
    handoffAfterMessages: 5,
    handoffConfidenceThreshold: 0.5,
  },

  dataSources: {
    pdfs: [],
    urls: [],
    faqs: [],
    customText: "",
  },
  links: [],
};
